import SelfResponseSummaryService from '@/Services/selfResponseSummaryService';
import { FilterItemDto } from '@/VueComponents/Filter/Dtos/filterItemDto';
import PageResultModel from '@/Models/pageResultModel';
import { ApplicationError } from '@/Services/Clients/applicationError';

let requestCounter = 0;

export function load(
  filterCriteria: FilterItemDto[],
  sortField: string,
  sortOrder: string,
  currentPage: number,
  pageSize: number,
  successCallback: (data: PageResultModel) => void,
  errorCallback: (error: ApplicationError) => void) {
  requestCounter++;
  const currentRequestCounter = requestCounter;
  return SelfResponseSummaryService.getSelfResponseSummaries(filterCriteria, sortField, sortOrder, currentPage, pageSize)
    .then(data => {
      // If the data was requested again during the current request processing, ignore the current results and wait for the
      // latest request to be processed.
      if (currentRequestCounter !== requestCounter) {
        return;
      }

      successCallback(data);
    })
    .catch((error: ApplicationError) => {
      // If the data was requested again during the current request processing, ignore the current results and wait for the
      // latest request to be processed.
      if (currentRequestCounter !== requestCounter) {
        return;
      }

      errorCallback(error);
    });
}